import React from "react";
import { IconButton, TooltipHost } from "@fluentui/react/lib";
import { classNames } from "maven-lib/dist/utils/misc";
import { CrButtonMenuItemProps, CrButtonMenuItemPropsTransformer, CrButtonProps } from "./CrButton";
import { IconName } from "../interface/Icon";

export interface CrIconButtonProps extends Omit<CrButtonProps, "text"> {
  elementRef?: React.RefObject<HTMLDivElement>;
  icon: IconName;
  tooltip?: string;
  tooltipDelay: 0 | 1 | 2;
  disabled?: boolean;
  menuItems?: CrButtonMenuItemProps[];
  countBadge?: number;
  closedBadge?: boolean;
  divClass?: string;
  className?: string;
  title?: string;
  isRedBadge?: boolean;
  badgeColor?: "PRIMARY" | "WARNING" | "DANGER" | "SUCCESS";
  hideBadge?: boolean;
}

export function CrIconButton(props: CrIconButtonProps) {
  const { icon, title, tooltip, tooltipDelay, disabled, menuItems, elementRef, countBadge, closedBadge, ...extras } = props;

  return (
    <div ref={elementRef} className={classNames("cr-icon-button", props.color, props.divClass)}>
      <TooltipHost hostClassName={props.className} delay={tooltipDelay} content={tooltip} calloutProps={{ gapSpace: 0 }}>
        <IconButton
          className={props.className}
          iconProps={{ iconName: icon }}
          disabled={disabled}
          menuIconProps={{ style: { display: "none" } }}
          menuProps={CrButtonMenuItemPropsTransformer(menuItems, {
            className: "cr-contextual-menu cr-icon-button",
            isBeakVisible: true,
            beakWidth: 10,
          })}
          {...extras}
          children={
            <>
              {!props.hideBadge && countBadge && (
                <div className={classNames("count-badge", `--${props.badgeColor?.toLowerCase() || "primary"}`)}>{countBadge}</div>
              )}
              {closedBadge && <div className="notice-badge"></div>}
              {title && <div>{title}</div>}
            </>
          }
        />
      </TooltipHost>
    </div>
  );
}

CrIconButton.defaultProps = {
  tooltipDelay: 0,
};
